import PropTypes from "prop-types";
import { useState } from "react";
import * as Icon from "react-feather";

import { useTranslation } from "react-i18next";
import { upperCase, capitalizeFirst } from "../../utils/manipulateText";

const ToolTip = ({
  title,
  content,
  children,
  minWidth = "auto",
  customStyle = "",
}) => {
  const { t } = useTranslation();
  const [showToolTip, setShowToolTip] = useState(false);

  const tooltipContent =
    typeof content === "string" ? (
      <span>{capitalizeFirst(t(content))}</span>
    ) : (
      content
    );

  return (
    <div
      className={`empower-tooltip relative ${customStyle}`}
      onMouseOver={() => {
        if (window.innerWidth >= 576) {
          setShowToolTip(true);
        }
      }}
      onMouseOut={() => {
        setShowToolTip(false);
      }}
    >
      <div>{children}</div>
      <div
        style={{ color: "#718096", minWidth }}
        className={`${
          showToolTip ? "block" : "hidden"
        } absolute z-10 md:p-2 mb-5 rounded-md transition duration-500 ease-in-out card shadow-md bg-white w-full tt-div`}
      >
        <div className="flex items-center justify-start my-1">
          <Icon.HelpCircle className="h-4 w-4 text-gray-600"></Icon.HelpCircle>
          <div style={{ fontSize: 13 }} className="md:font-bold text-md px-2">
            {upperCase(t(title))}
          </div>
        </div>
        <div
          style={{ fontSize: 11.5 }}
          className="md:font-light text-md pt-1 px-2"
        >
          {tooltipContent}
        </div>
      </div>
    </div>
  );
};

ToolTip.propTypes = {
  title: PropTypes.string.isRequired,
  content: PropTypes.any,
  children: PropTypes.any,
  customStyle: PropTypes.any,
};

export default ToolTip;
